import { put, fork, takeLatest, call } from 'redux-saga/effects';

import {
    SAVE_APPLICATION_COMPLETE,
    SAVE_APPLICATION_LOADING,
    ACTIVATE_SAVE_APPLICATION,
    SAVE_APPLICATION_FAILED
} from './SaveApplication.actions';
import { saveCustomerState } from '../../containers/AutomatedLendingDecision/AutomatedLendingDecisionUtils';
import { OPEN_MODAL } from '../../containers/Modals/Modals.actions';

export default [fork(activateSaveApplication)];

function* activateSaveApplication() {
    yield takeLatest(ACTIVATE_SAVE_APPLICATION, function* () {
        yield put({ type: SAVE_APPLICATION_LOADING });

        const stateStatus = yield call(saveCustomerState);

        if (stateStatus.type === 'SAVE_CUSTOMER_STATE_SUCCEED') {
            yield put({ type: SAVE_APPLICATION_COMPLETE });
        } else {
            yield put({ type: SAVE_APPLICATION_FAILED });

            yield put({
                type: OPEN_MODAL,
                modalId: 'errorSaveApplicationModal'
            });
        }
    });
}
